<template>
  <div>
    <!--  模板管理 -->
    <el-dialog :title="$t('message.templateManagement')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="888px" center>
      <div class="content">
        <div class="add">
          <el-button type="success" @click="addItem" v-if="isAuth(469)">{{
            $t("message.add")
          }}</el-button>
        </div>
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" size="small">
          <!-- 券名称 -->
          <el-table-column align="center" :label="$t('message.couponName')" prop="name_translation" width="200">
          </el-table-column>

          <!-- 类别 -->
          <el-table-column align="center" :label="$t('message.category')">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.type == 1 ? '#2C96E7' : '#B4272D' }" v-if="scope.row.type">{{
                scope.row.type_name
              }}</span>
            </template>
          </el-table-column>
          <!-- 额度/可用次数/折扣比例/ -->
          <el-table-column align="center" label="额度/可用次数/折扣比例/天">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.type == 1 ? '#2C96E7' : '#B4272D' }" v-if="scope.row.type != '3'">
                {{ scope.row.fee }}
              </span>
              <span v-else>
                {{
                  scope.row.fee && scope.row.fee != "0"
                    ? scope.row.fee
                    : scope.row.rate + "%"
                }}</span>
            </template>
          </el-table-column>

          <!-- 使用限制 -->
          <el-table-column align="center" :label="$t('message.useRestrictions')" prop="min_consumption">
            <template slot-scope="scope">
              <div v-if="scope.row.type <= 3">


                <span v-if="scope.row.type != '3'">订单金额 >={{ scope.row.min_consumption }}</span>
                <div v-else>
                  <p>订单金额 >={{ scope.row.min_consumption }}</p>
                  <p>计费重量 >={{ scope.row.min_weight }}</p>
                  <p>
                    <el-select :disabled="true" v-model="scope.row.logistics_id" multiple placeholder="全部物流">
                      <el-option v-for="(yitem, oindex) in Logisticsoptions" :key="oindex" :label="yitem.name"
                        :value="yitem.id">
                      </el-option>
                    </el-select>
                  </p>
                </div>
              </div>
              <div v-else>
                无
              </div>
            </template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')">
            <template slot-scope="scope">
              <!--编辑 -->
              <p style="margin-bottom: 10px" v-if="isAuth(469)">
                <el-button size="small" type="primary" class="primary" @click="edit(scope.row)">{{ $t("message.edit")
                }}</el-button>
              </p>
              <!-- 删除 -->
              <p v-if="isAuth(470)">
                <el-button size="small" type="primary" class="dark" @click="deleteDiscountGroup(scope.row.id)">
                  {{ $t("message.delete") }}
                </el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 新增 修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="addDialogVisible" width="598px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
          <!-- 券名称 -->
          <el-form-item :label="$t('message.couponName')" prop="name_translation">
            <el-input v-model="ruleForm.name_translation"></el-input>
          </el-form-item>
          <!-- 类别  -->
          <el-form-item :label="$t('message.category')" prop="type">
            <el-select v-model="ruleForm.type" placeholder="请选择" @change="changeType">
              <el-option v-for="item in options" :key="item.type" :label="item.name" :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="ruleForm.type != 3">
            <div>
              <!-- 额度/可用次数 -->
              <el-form-item label="额度/可用次数/天" prop="fee">
                <el-input v-model.number="ruleForm.fee" :disabled="ruleForm.type == 1"></el-input>
              </el-form-item>
              <!-- 使用限制 -->
              <el-form-item :label="$t('message.useRestrictions')" prop="min_consumption" v-if="ruleForm.type <= 3">
                <el-col :span="6">
                  <span style="color: #b4272d">订单金额</span>
                </el-col>
                <el-col class="line" :span="2">>=</el-col>
                <el-col :span="16">
                  <el-input v-model.number="ruleForm.min_consumption"></el-input>
                </el-col>
              </el-form-item>
            </div>
          </template>
          <template v-else>
            <div>
              <!-- 折扣金额 -->
              <el-form-item label="折扣金额" class="bitian">
                <el-input v-model.number="ruleForm.fee" oninput="value=value.replace(/[^0-9]/g,'')" @input="
                  !isNaN(ruleForm.fee) ? '' : (ruleForm.fee = null);
                delete ruleForm.rate;
                " :disabled="!!ruleForm.rate"></el-input>
              </el-form-item>
              <!-- 折扣比例 -->
              <el-form-item label="折扣比例" class="bitian">
                <el-input v-model.number="ruleForm.rate" oninput="value=value.replace(/[^0-9]/g,'')" @input="
                  ruleForm.rate > 100 ? (ruleForm.rate = 100) : '';
                delete ruleForm.fee;
                " :disabled="!!ruleForm.fee"><span slot="suffix">%</span></el-input>
              </el-form-item>
              <!-- 使用限制 -->
              <el-form-item :label="$t('message.useRestrictions')" prop="min_consumption">
                <el-col :span="6">
                  <span style="color: #b4272d">订单金额</span>
                </el-col>
                <el-col class="line" :span="2">>=</el-col>
                <el-col :span="16">
                  <el-input v-model.number="ruleForm.min_consumption"></el-input>
                </el-col>
              </el-form-item>
              <!-- 使用限制 -->
              <el-form-item :label="$t('message.useRestrictions')" prop="min_weight">
                <el-col :span="6">
                  <span style="color: #b4272d">计费重量</span>
                </el-col>
                <el-col class="line" :span="2">>=</el-col>
                <el-col :span="16">
                  <el-input v-model.number="ruleForm.min_weight"></el-input>
                </el-col>
              </el-form-item>
              <!-- 物流限制 -->
              <el-form-item label="物流限制" prop="logistics">
                <el-radio-group v-model="ruleForm.logistics" @change="
                  !ruleForm.logistics ? (ruleForm.logistics_id = []) : ''
                  ">
                  <el-radio :label="0" @click="ruleForm.logistics_id = ['4']">全部物流</el-radio>
                  <el-radio :label="1">
                    指定物流
                    <el-select :disabled="!ruleForm.logistics" v-model="ruleForm.logistics_id" multiple
                      placeholder="全部物流">
                      <el-option v-for="(yitem, oindex) in Logisticsoptions" :key="oindex" :label="yitem.name"
                        :value="yitem.id">
                      </el-option>
                    </el-select>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    var positiveInteger = (rule, value, callback) => {
      if (this.ruleForm.fee < 0) {
        callback(new Error("必须为正数字值"));
      }
      callback();
    };
    var positiveInteger1 = (rule, value, callback) => {
      if (value < 0) {
        callback(new Error("必须为正数字值"));
      }
      callback();
    };
    return {
      dialogVisible: false,
      tableData: [],
      Logisticsoptions: [],
      // 新增修改数据
      ruleForm: {},
      ruleFormItem: {}, //等待修改的模板数据
      rules: {
        name_translation: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        fee: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
          { type: "number", message: "必须为正数字值", trigger: "input" },
          {
            validator: positiveInteger,
            required: true,
          },
        ],
        min_consumption: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
          },
          { type: "number", message: "必须为正数字值", trigger: "input" },
          {
            validator: positiveInteger1,
            required: true,
          },
        ],
        rate: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
          },
          { type: "number", message: "必须为正数字值", trigger: "input" },
          {
            validator: positiveInteger1,
            required: true,
          },
        ],
        min_weight: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
          },
          { type: "number", message: "必须为正数字值", trigger: "input" },
          {
            validator: positiveInteger1,
            required: true,
          },
        ],
        logistics: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
          },
          { type: "number", message: "必须为正数字值", trigger: "input" },
          {
            validator: positiveInteger1,
            required: true,
          },
        ],
      },
      title: "",
      addDialogVisible: false,
      options: [],
    };
  },
  computed: {},
  created() {
    this.$api.clienteleApi.getDiscountGroupType().then((res) => {
      this.options = res.data;
    });
    this.$api.clienteleApi.getDiscountLogistics().then((res) => {
      res.data.forEach((element) => {
        element.id = element.id + "";
      });
      this.Logisticsoptions = res.data;
    });
    this.getDiscountGroup();
  },
  methods: {
    getDiscountGroup() {
      this.$api.clienteleApi.getDiscountGroup().then((res) => {
        res.data.forEach((dataItem) => {
          if (dataItem.logistics_id) {
            let arr = dataItem.logistics_id.split(",");
            dataItem.logistics_id = arr;
            dataItem.logistics = 1;
          } else {
            dataItem.logistics = 0;
          }
          if (!isNaN(dataItem.min_weight)) {
            dataItem.min_weight = Number(dataItem.min_weight);
          }
        });
        this.tableData = res.data;
      });
    },
    // 新增
    addItem() {
      this.title = this.$t("message.add");
      this.addDialogVisible = true;
      this.ruleForm = {
        name_translation: "",
        name_chinese: "",
        type: "",
        fee: "",
        logistics: 0,
        logistics_id: [],
        min_consumption: "",
      };
    },
    // 保存
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // let upData = JSON.parse(JSON.stringify(this.ruleForm));
          if (!this.ruleForm.logistics) {
            this.ruleForm.logistics_id = [];
          }
          // if (this.ruleForm.type == 3) {
          //   delete this.ruleForm.fee;
          // }
          // return console.log(upData);
          this.ruleForm.name_chinese = this.ruleForm.name_translation
          this.$api.clienteleApi
            .saveDiscountGroup(this.ruleForm)
            .then((res) => {
              this.ruleFormItem = this.ruleForm;
              this.$message.success(res.msg);
              this.addDialogVisible = false;
              this.getDiscountGroup();
            });
        }
      });
    },
    // 类别
    changeType(e) {
      if (this.ruleForm.type != 3) {
        this.ruleForm.fee = 1;
      } else {
        // this.ruleForm.fee = 0;
        delete this.ruleForm.fee;
        delete this.ruleForm.rate;
      }
      this.$refs.ruleForm.clearValidate();
      this.$forceUpdate();
    },
    //修改
    edit(item) {
      item.fee = item.fee - 0;
      item.min_consumption = item.min_consumption - 0;
      this.ruleForm = JSON.parse(JSON.stringify(item));
      this.ruleFormItem = item;
      this.title = this.$t("message.redact");
      this.addDialogVisible = true;
    },
    // 删除
    deleteDiscountGroup(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.clienteleApi.deleteDiscountGroup({ id }).then((res) => {
            this.$message.success(res.msg);
            this.getDiscountGroup();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin: 0px 15px;
}

.add {
  margin: -40px 0 20px;
  text-align: right;
}

/deep/.el-radio__input {
  transform: scale(1.5) !important;
}

/deep/.el-select {
  width: 100%;
}

/deep/.bitian {
  .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>
